import { 
		collection,
		doc,
		query,
		where,
		orderBy as fsOrderBy,
		limit,
		startAfter,
		getDoc,
		getDocs,
		setDoc,
    updateDoc
	} from "firebase/firestore"; 
import { 
		getAuth, 
		createUserWithEmailAndPassword, 
		signInWithEmailAndPassword, 
		signOut,
    sendPasswordResetEmail
	} from "firebase/auth";

import { db } from '../main'
import { oldDB } from '../main'
import Vue from 'vue'
import Vuex from 'vuex'
import helpers from '@/helpers.js'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { intersection, orderBy, union, merge } from "lodash"
import localisation from "@/setup"
import LogRocket from 'logrocket';
import lo from "@/setup";
import { resolve } from "core-js/fn/promise";

Vue.use(Vuex)

// https://medium.com/vue-mastery/vuex-explained-visually-f17c8c76d6c4
export default new Vuex.Store({
  state: {
    userAuth: null, // where we store the object we get from FB auth
    userData: null, // Where we keep the data we have on the user in our databse
    userAdminStatus: false,
    activeOrg: null, // the org currently active, that the user is looking at
    activeOrgSecure: null,
    activeOrgAccess: "guest", // used throughout app to handle UI change based on access level. NOT for security. Frontend only
    orgs: [], // all available orgs to the user
    guestInvites: [],
    users: {
      boundDirectory: {},
      docs: []
    },
    resources: {
			boundDirectory: {},
			docs: []
		},
    groups: {
			boundDirectory: {},
			docs: []
		},
    logs: {
			boundFile: {},
      queryCursor: null,
			loadedAll: false,
			staticLogs: [],
    },
  },
  mutations: {
    ...vuexfireMutations,
    SET_USERAUTH(state, payload) {
      state.userAuth = payload;
    },
    SET_USERDATA(state, payload) {
      state.userData = payload;
    },
    SET_ACTIVEORG(state, payload) {
      state.activeOrg = payload;
    },
    SET_ACTIVEORG_ACCESS(state, payload){
      state.activeOrgAccess = payload
    },
    SET_ORGS(state, payload) {
      state.orgs = payload;
    },
    UPDATE_DOC(state, payload) {
      // could be an update, addition or deletion
      // payload should look like:
      /*
					{
						action: // delete/add/update
						docType: // the data store to update
						data: // the updated doc
					}
				*/
      console.log("UPDATING DOC:", payload);
			let elIndex = state[payload.docType]["docs"].map(el => el.id).indexOf(payload.data.id)
			console.log('elIndex:', elIndex);

			// debugger

      if (payload.action !== "delete") {
				// find the element in the array to update or add
				if (elIndex < 0) {
          console.log("doc is not in here, push it");
          state[payload.docType]["docs"].push({...payload.data});
					return
        } else {
          // we have an index, update it
          let docData = state[payload.docType]["docs"][elIndex];
					console.log("doc IS here:", docData)

          // if we have a full doc (coming from fetchDocData call)
          // then use that without question
          if(payload.fullDoc){
            Vue.set(state[payload.docType]["docs"], elIndex, payload.data);
          } else {
            // it's just an update to the directory
            // we only want to update certain fields
              // name
              // tags
              // flags
              docData.name = payload.data.name
              docData.tags = payload.data.tags
              docData.flags = payload.data.flags
              Vue.set(state[payload.docType]["docs"], elIndex, docData);
          }

        }
				console.log(
					`STORE: ${state[payload.docType]["docs"][elIndex]['id']} updated to: `,
					state[payload.docType]["docs"][elIndex]
				);
      } else if (payload.action === "delete" && elIndex >= 0) {
        // find the element in the array to remove
				Vue.delete(state[payload.docType]["docs"], elIndex);
				console.log(`Doc ${payload.data.id} was removed from the store`)
      }

    },
    UPDATE_LOGS(state, payload) {
      state.logs[payload.key] = payload.value;
    },
		RESET_LOGS(state) {
			// used when we need to entirely refresh logs
			state.logs = {
				boundFile: {},
				queryCursor: null,
				loadedAll: false,
				staticLogs: []
			}
			console.log("LOGS cleared:", state.logs)
		},
		CLEAR_DOCS(state) {
			console.log("CLEAR_DOCS")
			state.resources.docs = []
			state.groups.docs = []
			console.log("CLEAR_DOCS done");
		},
    SET_USER_ADMIN_STATUS(state, payload){
      console.log("SETTING ADMIN STATUS")
      state.userAdminStatus = payload
    }
  },
  actions: {
    async setUserAdminStatus(context) {
      let claims = await helpers.getUserClaims()
      let isAdmin = claims.admin ? true :false
      console.log('isAdmin', isAdmin);
      context.commit("SET_USER_ADMIN_STATUS", isAdmin)
    },
    setOrgByName(context, payload) {
      // set from the router when a user navigates to a page where
      // the org does not match the current one in memory
      console.log("setOrgByName: payload:", payload);

      return new Promise(async (resolve, reject) => {
        // paylod is the org name
        // filter the available orgs for that name
        let orgToSet = context.state.orgs.filter((obj) => {
          return obj.name === payload;
        })[0];

        if (!orgToSet) {
          // we don't have the org in the store, check DB
          // try get that org from the database
          console.log("context.state.userData:", context.state.userData);

          try {
            let orgQuery;

            let claims = await helpers.getUserClaims()
            console.log('claims:', claims);
            
            let isAdmin = claims.admin ? true :false
            console.log('isAdmin', isAdmin);
            
            if(isAdmin){
              orgQuery = query(
                collection(db, "orgs"),
                where("name", "==", payload),
                where("archived", "!=", true)
              )
            } else {
              orgQuery = query(
                collection(db, "orgs"),
                where("guests", "array-contains", context.state.userData.id),
                where("name", "==", payload),
                where("archived", "!=", true)
              )
            }
            
            let orgResults = await getDocs(orgQuery);

            console.log('orgResults', orgResults);

            if (orgResults.empty) {
              throw new Error("No org found :(");
            }

            let orgData = orgResults.docs[0].data();
            orgData.access = "guest";
            orgData.id = orgResults.docs[0]["id"];

            // check if they have teammate access
            if (
              orgData.teammates.includes(context.state.userData.id) ||
              isAdmin
            ) {
              orgData.access = "teammate";
            }

            orgToSet = orgData;
          } catch (error) {
            console.log("error getting active org:", error);
            resolve(false);
          }
        }

        // we have an org, make it the active one
        context.dispatch("setActiveOrg", orgToSet);

        resolve(orgToSet);
      });
    },
    async getOrgs(context, payload) {
      // get all the orgs that the user has access to, limited to 10 for now
      console.log("getting orgs for payload:", payload);

      let id = payload.id || payload.uid;

      return new Promise(async (resolve, reject) => {
        try {
          if (!id) throw "id is required";
          let orgs = [];

          let userClaims = await helpers.getUserClaims()
          console.log('userClaims:', userClaims);
          
          let orgQuery;

          if (userClaims.admin) {
            // we got an admin over here
            orgQuery = query(
              collection(db, "orgs"),
              where("archived", "!=", true),
              fsOrderBy("archived", "desc"),
              fsOrderBy("updatedDate", "desc"),
              limit(20)
            );
          } else {
            orgQuery = query(
              collection(db, "orgs"),
              where("guests", "array-contains", id),
              where("archived", "!=", true),
              limit(10)
            );
          }

          let orgDocs = await getDocs(orgQuery);

          orgDocs.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id;
            if (data.teammates.includes(id) || userClaims.admin) {
              data.access = "teammate";
            } else {
              data.access = "guest";
            }
            
            orgs.push(data);
          });

          // set all orgs in state
          context.commit("SET_ORGS", orgs);

          resolve(orgs);
        } catch (e) {
          console.log("error getting orgs:", e);
          reject(e);
        }
      });
    },
    bindOrg: firestoreAction(async ({ bindFirestoreRef }, payload) => {
      // return the promise returned by `bindFirestoreRef`

      console.log("binding to:", payload.name);
      console.log("binding with:", payload.id);

      if (!payload) return false;

      try {
        let bound = await bindFirestoreRef(
          "activeOrg",
          oldDB
            .collection("orgs")
            .withConverter(helpers.orgConverter)
            .doc(payload.id)
        );
        return bound;
      } catch (e) {
        console.log("Org binding error:", e);
        // try again - we need to wait for doc to be created...
        return new Error(e);
      }
    }),
    bindSecureOrg: firestoreAction( async ({ bindFirestoreRef }, payload) => {

      let success = false

      for (let index = 1; index < 5; index++) {
        if(success) break
        try {
          console.log(
            `Attempt ${index} of binding secureOrg, payload:`,
            payload
          );

          let bound = await bindFirestoreRef(
            "activeOrgSecure",
            oldDB
              .collection("orgsSecure")
              .doc(payload.id)
          );
          if (!bound) throw "no binding yet";
          success = true
          return bound
        } catch (error) {
          console.log("secureOrg binding error:", error);
          console.log(`This was try ${index} of 4`)
          // progressively wait longer between requests
          let ms = 2000 * index;
          await helpers.wait(ms)
        }
      }
    }),
    bindResourceDirectory: firestoreAction(

      async ({ bindFirestoreRef }, payload) => {

        let success = false

        for (let index = 1; index < 5; index++) {
          if(success) break
          try {
            console.log(
              `Attempt ${index} of binding resourceDirectory, payload:`,
              payload
            );

            let bound = await bindFirestoreRef(
              "resources.boundDirectory",
              oldDB
                .collection("orgs")
                .doc(payload.id)
                .collection("directories")
                .doc("resourceDirectory")
            );
            if (!bound) throw "no binding yet";
            success = true
            return bound
          } catch (error) {
            console.log("resourceDirectory binding error:", error);
            console.log(`This was try ${index} of 4`)
            // progressively wait longer between requests
            let ms = 2000 * index;
            await helpers.wait(ms)
          }
        }

      }
    ),
    bindGroupDirectory: firestoreAction(
      async ({ bindFirestoreRef }, payload) => {

        let success = false

        for (let index = 1; index < 5; index++) {
          if(success) break
          try {
            console.log(`Attempt ${index} of binding groupDirectory, payload:`, payload)

            let bound = await bindFirestoreRef(
            "groups.boundDirectory",
              oldDB
                .collection("orgs")
                .doc(payload.id)
                .collection("directories")
                .doc("groupDirectory")
            );
            if (!bound) throw "no binding yet";
            success = true
            return bound
          } catch (error) {
            console.log("groupDirectory binding error:", error);
            console.log(`This was try ${index} of 4`)
            // progressively wait longer between requests
            let ms = 2000 * index;
            await helpers.wait(ms)
          }
        }

      }
    ),
    bindLogFile: firestoreAction(async ({ bindFirestoreRef }, payload) => {

      let success = false

      for (let index = 1; index < 5; index++) {
        if(success) break
        try {
          console.log(`Attempt ${index} of binding logs, payload:`, payload)
          let bound = await bindFirestoreRef(
            "logs.boundFile",
            oldDB
              .collection("orgs")
              .doc(payload.orgId)
              .collection("logs")
              .doc(payload.docId)
          );
          console.log("logs bound:", bound);
          if (!bound) throw "no binding yet";
          success = true
          return bound
        } catch (error) {
          console.log("Logfile binding error:", error);
          console.log(`This was try ${index} of 4`);
          // progressively wait longer between requests
          let ms = 2000 * index;
          await helpers.wait(ms);
        }
      }

    }),
    bindUserDirectory: firestoreAction( async ({bindFirestoreRef}, payload) => {

      let success = false

      for (let index = 1; index < 5; index++) {
        if(success) break
        try {
          console.log(`Attempt ${index} of binding userDirectory, payload:`, payload)
          let bound = await bindFirestoreRef(
            "users.boundDirectory",
            oldDB
              .collection("orgs")
              .doc(payload.id)
              .collection("directories")
              .doc("userDirectory")
          );
          console.log("user directory bound:", bound)
          if(!bound) throw "no binding yet"
          success = true
          return bound
        } catch (error) {
          console.log("userdirectory binding error:", error);
          console.log(`This was try ${index} of 4`)
          // progressively wait longer between requests
          let ms = 2000 * index;
          await helpers.wait(ms)
        }
      }

    }),
    async fetchNextLogFile(context, payload) {
      console.log("fetching next log file:", payload);
			// console.log('context.state.logs:', context.state.logs);

      if(!context.state.logs.queryCursor ){
        // we haven't bound a file yet, loop till we get a response (or hit 4)
        let success = false

        for (let index = 1; index < 5; index++) {
          if(success) break
          try {
            console.log(`Trying for log files, attempt ${index} of 4`)
            let files = await getDocs(
              query(
                collection(db, "orgs", payload.id, "logs"),
                fsOrderBy("started", "desc"),
                limit(1),
                startAfter(new Date())
              )
            );
            if(!files.empty) {
              success = true
              await context.dispatch("bindLogFile", {
                orgId: payload.id,
                docId: files.docs[0]["id"],
              });
              // update the query cursor
              context.commit("UPDATE_LOGS", {
                key: "queryCursor",
                value: files.docs[0].data()['started'],
              });
              break
            } 
          } catch (error) {
            console.log("Fetchnextlogfile error:", error);
          } finally {
            console.log(`This was try ${index} of 4`);
            // progressively wait longer between requests
            let ms = 2000 * index;
            console.log(`trying again in ${ms}ms if no file found`)
            await helpers.wait(ms);
          }
        }

      } else {
        // we've already gotten at least one file, we have a querycursor
        let files = await getDocs(
          query(
            collection(db, "orgs", payload.id, "logs"),
            fsOrderBy("started", "desc"),
            limit(1),
            startAfter(context.state.logs.queryCursor)
          )
        );
        
        if (files.empty) {
          // console.log("No more log files")
          context.commit("UPDATE_LOGS", {
            key: "loadedAll",
            value: true,
          });
          return;
        } else {
          // we have a bound file, AND we have another file to add to static logs          
          let allLogs
          let firstFileData = files.docs[0].data();

          // we already have a bound file, so this file can go to static logs
          allLogs = union(
            context.state.logs.staticLogs,
            firstFileData.events
          );

          // sort the logs
          allLogs.sort((a, b) => {
            if (a.at < b.at) {
              return 1;
            }
            if (a.at > b.at) {
              return -1;
            }
            return 0;
          });

          // we have a bound file, so add these logs to the static ones
          context.commit("UPDATE_LOGS", {
            key: "staticLogs",
            value: allLogs,
          });

          // update the query cursor
          context.commit("UPDATE_LOGS", {
            key: "queryCursor",
            value: firstFileData.started,
          });

          let totalEventCount =
            context.state.logs.staticLogs.length +
            context.state.logs.boundFile.events
              ? context.state.logs.boundFile.events.length
              : 0;
          // console.log('totalEventCount:', totalEventCount);

          if (totalEventCount > 0 < 10) {
            // we need to do something to go again
            context.dispatch("fetchNextLogFile", payload);
          }
        
        }
      
      }

    },
    async setActiveOrg(context, payload) {
      // payload will be an org object
      console.log("setting active org:", payload);

      context.commit("SET_ACTIVEORG_ACCESS", "guest");
			context.commit("RESET_LOGS")
			context.commit("CLEAR_DOCS")

      if (!payload) {
        // user wants to set nothing as the active org
        context.commit("SET_ACTIVEORG", null);
        return;
      }

      return new Promise((resolve, reject) => {
        try {

          let selectedOrg = payload;

          console.log("selectedOrg:", selectedOrg);

          if (!selectedOrg) {
            throw "No organisation found matching that name";
          }

          if (selectedOrg.access === "teammate") {
            // bind to the users directory
            context.dispatch("bindUserDirectory", payload);
            // bind to secure org
            context.dispatch("bindSecureOrg", selectedOrg);
            // user can view logs
            context.dispatch("fetchNextLogFile", payload);
            // set acess level in state for use all over app
            context.commit("SET_ACTIVEORG_ACCESS", "teammate" )
          }

          context.dispatch("bindOrg", payload);
          context.dispatch("bindResourceDirectory", payload);
          context.dispatch("bindGroupDirectory", payload);

          context.commit("SET_ACTIVEORG", selectedOrg);

          // handle custom localisations if there are any
          if (
            Object.entries(selectedOrg.customisations.localeOverrides)
              .length !== 0
          ) {
            var userLang = navigator.language || navigator.userLanguage;

            userLang += "-custom";

            localisation.loadLanguageAsync(
              userLang,
              selectedOrg.customisations.localeOverrides
            );
          }

          resolve(selectedOrg);
        } catch (error) {
          console.log("eror setting active org:", error);
          reject(error);
        }
      });
    },
    // eslint-disable-next-line
    setUserAuth({ commit, dispatch }, payload) {
      console.log("setting userAuth:", payload);
      return new Promise(async (resolve, reject) => {
        try {
          if (!payload) {
            // 're setting the user as null
            commit("SET_USERAUTH", null);
            resolve();
          } else {
            LogRocket.identify(payload.uid, {
              name: payload.displayName,
              email: payload.email,
              emailVerified: payload.emailVerified,
            });

            commit("SET_USERAUTH", payload);
            // dispatch("getOrgs", payload)
            resolve(payload);
          }
        } catch {
          reject("err setUserAuth");
        }
      });
    },
    updateDoc({ commit }, payload) {
			console.log("updateDoc:: payload:", payload)
      commit("UPDATE_DOC", payload);
    },
    bindUserData: firestoreAction(async ({ bindFirestoreRef }, id) => {
      // return the promise returned by `bindFirestoreRef`
      console.log("bindUserData with id:", id);
      try {
        let bound = await bindFirestoreRef(
          "userData",
          oldDB
            .collection("users")
            .withConverter(helpers.userDataConverter)
            .doc(id)
        );

        return bound;
      } catch (e) {
        console.log("binding error:", e);
        // try again - we need to wait for doc to be created...
        return new Error(e);
      }
    }),
    signIn({ commit, dispatch }, payload) {
      console.log("signing user IN from store:", payload);
      return new Promise(async (resolve, reject) => {
        try {
          const auth = getAuth();
          let data = await signInWithEmailAndPassword(
            auth,
            payload.userEmail,
            payload.userPassword
          );

          console.log("firebase auth data:", data);

          // save auth data
          commit("SET_USERAUTH", data.user);

          // go get user's data from our DB
          await dispatch("bindUserData", data.user.uid);
          dispatch('setUserAdminStatus')
          // resolve
          resolve(data.user);
        } catch (err) {
          reject(err);
        }
      });
    },
    resetUserPassword(context, payload) {
      console.log('store: resetting user password:', payload);
      return new Promise(async (resolve, reject) => {
        const auth = getAuth();
        let result
        try {
          await sendPasswordResetEmail(auth, payload)
          result = {
            error: false
          }
        } catch (error) {
          console.log("Error resetting password:", error)
          result = {
            error: error
          }
        }
        resolve(result)
      })
    },
    // eslint-disable-next-line
    async signUp({ commit, dispatch }, payload) {
      console.log("signing user UP from store:", payload);
      return new Promise(async (resolve, reject) => {
        let newUserAuth;
        // attempt to sign user up
        try {
          const auth = getAuth();
          newUserAuth = await createUserWithEmailAndPassword(
            auth,
            payload.email,
            payload.password
          );
        } catch (e) {
          console.log("err signing new user up:", e);
          console.log('e.code:', e.code);
          console.log('e.message:', e.message);
          
          
          return reject(e);
        }

        // set userAuth state
        dispatch("setUserAuth", newUserAuth.user);

        let obj = {
          email: payload.email,
          uid: newUserAuth.user.uid,
        };

        // get the user data
        await dispatch("createUserData", newUserAuth.user);
        await dispatch("bindUserData", newUserAuth.user.uid);

        // console.log("singed user up, and ran getUserData")
        resolve(obj);
      });
    },
    // eslint-disable-next-line
    async createUserData({ commit, dispatch }, payload) {
      console.log("creating user data with:", payload);
      // we need to create a user object for this person
      // console.log('creating User Data:', payload);

      return new Promise(async (resolve, reject) => {
        
        try {
          let docData = await setDoc(doc(db, "users", payload.uid), {
            email: payload.email,
            config: {
              locale: helpers.getLang(),
            },
          });
  
          resolve(docData);
          
        } catch (error) {
          console.log("Error creating user data:", error)
          reject(error)
        }
      });
    },
    async updateUserData(context, payload) {
      console.log("updating user data:", payload)
      // {
      //   // key: the key to use. Could be "a.deep.property"
      //   // value: the value to set for it
      // }
      try {
        await updateDoc(doc(db, "users", payload.uid), {
          [payload.key]: payload.value
        });

      } catch (error) {
        console.log("Error updating user data:", error)
      }

    },
    // eslint-disable-next-line
    async createOrg(context, payload) {
      console.log("creating org:", payload);

      return new Promise(async (resolve, reject) => {
        try {
          let orgData = new helpers.Org({
            owner: {
              email: payload.email,
              id: payload.id,
            },
            teammates: [payload.id],
            guests: [payload.id],
            name: payload.locationName,
          });

          console.log("orgData:", orgData);

          // Add a new document in collection "cities"
          await setDoc(
            doc(db, "orgs", orgData.id).withConverter(helpers.orgConverter),
            { ...orgData },
            { merge: true }
          );

          resolve(orgData);
        } catch (error) {
          console.log("error creating org:", error);
          reject(error);
        }
      });
    },
    signOut({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const auth = getAuth();
          await signOut(auth);

          commit("SET_USERAUTH", null);
          commit("SET_USERDATA", null);
          commit("SET_USER_ADMIN_STATUS", false)
          commit("SET_ORGS", null);
          commit("SET_ACTIVEORG", null);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    fetchDocData(context, options) {
			// handles resources and groups
      console.log("fetchDocData:options:", options);

      let query;

      if (options.collection === "resources") {
        query = doc(
          db,
          "orgs",
          context.state.activeOrg.id,
          options.collection,
          options.id
        ).withConverter(helpers.resourceConverter);
      } else if (options.collection === "groups") {
        query = doc(
          db,
          "orgs",
          context.state.activeOrg.id,
          options.collection,
          options.id
        ).withConverter(helpers.groupConverter);
      }

      let localDoc = context.state[options.collection]["docs"][options.id];

      return new Promise(async (resolve, reject) => {
        try {
          if (localDoc && localDoc.loadedData && !options.forceRefresh) {
            console.log("resolving with localDoc:", localDoc);
            resolve(localDoc);
          }

          console.log(
            `Getting doc from DB, type: ${options.collection}, id:${options.id}`
          );

          let resQuery = await getDoc(query);

          let docData = {};
          // console.log('resQuery:', resQuery);

          if (!resQuery.exists()) {
            // nothing found for this ID
            docData = {
              notFound: true,
              id: options.id,
              loadedData: true,
            };
          } else {
            docData = resQuery.data();
          }

          console.log("docData:", docData);

          context.commit("UPDATE_DOC", {
            data: docData,
            action: "add",
            docType: options.collection,
            fullDoc: true
          });

          resolve(docData);
        } catch (error) {
          console.log("error getting doc data:", error);
          reject(error);
        }
      });
    }
  },
  getters: {
    userAuth(state) {
      return state.userAuth;
    },
    activeOrg(state) {
      return state.activeOrg;
    },
    activeOrgSecure(state) {
      return state.activeOrgSecure;
    },
    activeOrgAccess(state){
      return state.activeOrgAccess
    },
    allOrgs(state) {
      return state.orgs;
    },
    groupsTags(state) {
      let tags = [];
      // for every resource, get it's tags, union them to a tags array
      for (const res in state.groups.boundDirectory) {
        if (Object.hasOwnProperty.call(state.groups.boundDirectory, res)) {
          const element = state.groups.boundDirectory[res];
          tags = union(tags, element.tags);
        }
      }
      return tags;
    },
    docFiles(state) {
      // used to return filtered resource and group documents
      return(filter, type) => {
        console.log(`getting ${type} docs, filter: ${JSON.stringify(filter)}`)

        let results = [ ...state[type]['docs'] ]

        if (filter && filter.tags && filter.tags.length) {
          // we're filtering by tags

          results = results.filter(res => {
            let inter = intersection(filter.tags, res["tags"]);
            if (inter.length !== filter.tags.length) return false
            return true
          })

        }

        // Handle groups filter - only applicable for resources lookup
        if (filter && filter.group) {
          let groupData = state.groups.docs.find(
            (gr) => gr.id === filter.group.id
          );
          console.log("groupData:", groupData);

          let resourcesInGroup = groupData.linkedResources;

          // filter out results that aren't in this group
          results = results.filter((res) => {
            if (resourcesInGroup.includes(res.id)) return true;
            return false;
          });
        }

        // filter out archived (we need this if a user deletes (archives) a resource - or if cloud function screws up and directory isn't updated correctly
        // results = results.filter(x => !x.archived)

        // sort the results, by name
        results.sort((a, b) => {
          if(a.name > b.name) {
            return 1
          } else {
            return -1
          }
        })

        console.log("RESULTS:", results);

        return results;
      }
    },
    group(state) {
      return (id) => {
        let group = state.groups.docs.find(doc => doc.id === id);
        return group;
      };
    },
    resourcesTags(state) {
      let tags = [];
      // state.resources.boundDirectory
      // for every resource, get it's tags, union them to a tags array
      for (const res in state.resources.boundDirectory) {
        if (
          Object.hasOwnProperty.call(state.resources.boundDirectory, res)
        ) {
          const element = state.resources.boundDirectory[res];
          tags = union(tags, element.tags);
        }
      }
      return tags;
    },
    resource(state) {
      return (id) => {
        let resource = state.resources.docs.find(doc => doc.id === id);
        return resource;
      };
    },
    guestInvites(state) {
      return state.guestInvites;
    },
    userData(state) {
      return state.userData;
    },
    activeOrgReady(state) {
      console.log("checking active org for status")
      /* 
        When creating an org, we need to wait for a few things like
        the audit log file etc. 
        This function returns true or false and instructs the /create page to advance or not

      */
     return false
    },
    formatUser(state) {
      return (id) => {
        if (id == state.userData.id) return lo.i18n.t("audit-log-you");
        if (state.users.boundDirectory && state.users.boundDirectory.users) {
          let userInfo = state.users.boundDirectory.users[id];
          if (userInfo) {
            return userInfo.em;
          }
        }
        return lo.i18n.t("users-Unknown");
      }
    },
  },
});